export default "__VITE_ASSET__L1rb92mV__"